import { inject } from '@angular/core';

import { AuthService } from '@bn/auth/services';

import { PartnerRole } from '../enums';

/** Whether the logged-in partner has the given role. Must be called in an injection context. */
export function hasPartnerRole(role: PartnerRole): boolean {
  const roles = (inject(AuthService).authStoreValue?.user?.Roles ?? []) as unknown as string[];
  return roles.includes(role);
}
